import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTasksArchiveAvailableFilters = (projectId) => {
  return useQuery({
    queryKey: ["project_tasks_archive_available_filters", projectId],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/archive/available-filters`,
      }),
  });
};
